"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPtToSyRate = exports.getPriceFromCoinGecko = exports.getPriceInUsdFromPyth = void 0;
const axios_1 = __importDefault(require("axios"));
const common_1 = require("./common");
const multi_transaction_1 = require("multi-transaction");
const viem_1 = require("viem");
async function getPriceInUsdFromPyth(apiUrl, priceFeedId, timestamp) {
    timestamp = timestamp ? (0, common_1.ms2sec)(timestamp) : undefined;
    try {
        const result = await (0, axios_1.default)({
            method: 'GET',
            url: `${apiUrl}/updates/price/${timestamp ?? 'latest'}`,
            headers: {
                accept: 'application/json',
            },
            params: {
                'ids[]': priceFeedId,
            },
        });
        const priceRaw = result.data.parsed[0].price.price;
        const exp = result.data.parsed[0].price.expo;
        return multi_transaction_1.Units.format(priceRaw, Math.abs(exp));
    }
    catch (e) {
        throw Error(`Failed to getPriceInUsdFromPyth: ${e}`);
    }
}
exports.getPriceInUsdFromPyth = getPriceInUsdFromPyth;
async function getPriceFromCoinGecko(apiUrl, coingeckoTokenId) {
    try {
        const result = await (0, axios_1.default)({
            method: 'GET',
            url: `${apiUrl}/simple/price`,
            headers: {
                accept: 'application/json',
            },
            params: {
                ids: coingeckoTokenId,
                vs_currencies: 'usd',
            },
        });
        return (0, multi_transaction_1.BigNumber)(result.data[coingeckoTokenId].usd);
    }
    catch (e) {
        throw Error(`Failed to getPriceFromCoinGecko: ${e}`);
    }
}
exports.getPriceFromCoinGecko = getPriceFromCoinGecko;
async function getPtToSyRate(client, pendleOracleAddress, pendleMarketAddress, duration = 15 * 60) {
    return client.readContract({
        address: pendleOracleAddress,
        abi: (0, viem_1.parseAbi)([
            'function getPtToSyRate(address market, uint32 duration) external view returns (uint256)',
        ]),
        functionName: 'getPtToSyRate',
        args: [pendleMarketAddress, duration],
    });
}
exports.getPtToSyRate = getPtToSyRate;
//# sourceMappingURL=price.js.map